export function documentConfirmed(read: boolean, checked: boolean): boolean {
  return read && checked;
}

export function registrationReady(terms: { read: boolean; checked: boolean }, privacy: { read: boolean; checked: boolean }): boolean {
  return documentConfirmed(terms.read, terms.checked) && documentConfirmed(privacy.read, privacy.checked);
}
